"use strict";

// import Vue from "vue";
import axios from "axios";
import store from "@/store";
import { BASEURL } from "../utils/globals";
import { logout } from "@/api/auth";
import Vue from "vue";
import router from "@/router";

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

let options = {
    baseURL: BASEURL + process.env.VUE_APP_API,
    withCredentials: true, // Check cross-site Access-Control
    timeout: 60 * 1000, // Timeout
};

if (Capacitor.isNative || process.env.NODE_ENV === "development") {
    options.headers = {
        "X-Requested-From": "APP-API",
    };
}

let _axios = axios.create(options);

const setAxiosBaseurl = async function (baseurl) {
    if (baseurl === "") {
        baseurl = "www";
    }
    _axios.defaults.baseURL =
        "https://" + baseurl + ".klickmal.at" + process.env.VUE_APP_API;
    options.baseURL = _axios.defaults.baseURL;
    sessionStorage.removeItem("csrftoken");
};

let csrfTokenPromise = {};

let getCSRFToken = function () {
    csrfTokenPromise = axios.post(
        "?Mode=General&Function=GetCSRFToken",
        {},
        options
    );
    return csrfTokenPromise;
};

function promiseState(p) {
    const t = {};
    return Promise.race([p, t]).then(
        (v) => (v === t ? "pending" : "fulfilled"),
        () => "rejected"
    );
}

function handleCSRFError() {
    sessionStorage.removeItem("csrftoken");
    store.commit(
        "setErrorMessage",
        "Es ist ein Fehler mit deiner Sitzung aufgetreten. Die Seite wird in 3 Sekunden neu geladen."
    );
    setTimeout(function () {
        window.location.reload();
    }, 3000);
    store.commit("setError", true);
}

_axios.interceptors.request.use(
    async function (config) {
        // Do something before request is sent
        store.commit("incrementLoadingCount");
        if (!(Capacitor.isNative && Capacitor.platform === "android")) {
            // console.log("csrftoken: " + sessionStorage.getItem("csrftoken"));
            if (
                config.headers.url !== "?Mode=General&Function=GetCSRFToken" &&
                sessionStorage.getItem("csrftoken") !== null
            ) {
                config.headers["X-CSRF-TOKEN"] = sessionStorage.getItem(
                    "csrftoken"
                );
                return config;
            } else {
                const state = await promiseState(csrfTokenPromise);
                // console.log(state);
                if (state !== "pending") {
                    // console.log("1");
                    const response = await getCSRFToken();
                    if (response.data.Status === 200) {
                        const csrftoken = response.data.Result.CSRFToken;
                        sessionStorage.setItem("csrftoken", csrftoken);
                        config.headers["X-CSRF-TOKEN"] = sessionStorage.getItem(
                            "csrftoken"
                        );
                    } else {
                        handleCSRFError();
                    }
                    return config;
                } else {
                    // console.log("2");
                    const responses = await Promise.all([csrfTokenPromise]);
                    if (responses[0].data.Status === 200) {
                        config.headers["X-CSRF-TOKEN"] = sessionStorage.getItem(
                            "csrftoken"
                        );
                    } else {
                        handleCSRFError();
                    }
                    return config;
                }
            }
        } else {
            return config;
        }
    },
    function (error) {
        // Do something with request error
        store.commit("decrementLoadingCount");
        if (store.state.loadingCount === 0) {
            store.commit("setLoading", false);
        }
        store.commit(
            "setErrorMessage",
            "Beim Aufruf des Services ist ein Fehler aufgetreten. Bitte versuche es noch einmal."
        );
        store.commit("setError", true);
        return Promise.reject(error);
    }
);

// Add a response interceptor
_axios.interceptors.response.use(
    function (response) {
        // Do something with response data
        // console.log(router.currentRoute);
        // console.log(router.currentRoute.matched[0].path);
        // console.log(response);
        let requestUrl = new URL(response.config.url, window.location.origin);
        let requestUrlFunctionParam = requestUrl.searchParams.get("Function");
        // console.log(requestUrlFunctionParam);
        let path = router.currentRoute.path;
        if ("contractId" in router.currentRoute.params) {
            path = path.replace(/\d(?=\d{3})/g, "X");
        }
        Vue.gtm.trackEvent({
            // event: null, // Event type [default = 'interaction'] (Optional)
            category: "Service Aufruf",
            action: requestUrlFunctionParam,
            label: path,
            // value: 5000,
            // noninteraction: false // Optional
        });
        store.commit("decrementLoadingCount");
        if (store.state.loadingCount === 0) {
            store.commit("setLoading", false);
        }
        store.commit("setErrors", {});
        if (
            response.data.Status === 400 &&
            !(
                response.config.url.includes("ChangeFlexibleLife") &&
                Object.keys(response.data.Errors).length === 1 &&
                ("risiko" in response.data.Errors ||
                    "sendemail" in response.data.Errors)
            ) &&
            !(
                response.config.url.includes("VideoCallGenerate") &&
                Object.keys(response.data.Errors).length === 1 &&
                "password" in response.data.Errors
            )
        ) {
            if ("notloggedin" in response.data.Errors) {
                logout();
            } else if ("GeneralCsrfToken" in response.data.Errors) {
                sessionStorage.removeItem("csrftoken");
            } else {
                if (Object.keys(response.data.Errors).length === 1) {
                    store.commit(
                        "setErrorMessage",
                        response.data.Errors[
                            Object.keys(response.data.Errors)[0]
                        ]
                    );
                } else if ("general" in response.data.Errors) {
                    store.commit(
                        "setErrorMessage",
                        response.data.Errors.general
                    );
                } else if ("agentnotfound" in response.data.Errors) {
                    store.commit(
                        "setErrorMessage",
                        response.data.Errors.agentnotfound
                    );
                } else if ("activate" in response.data.Errors) {
                    store.commit(
                        "setErrorMessage",
                        response.data.Errors.activate
                    );
                } else if (Object.keys(response.data.Errors).length > 1) {
                    store.commit(
                        "setErrorMessage",
                        "Es ist ein Fehler aufgetreten. Bitte kontrolliere alle Eingabefelder und versuche es dann noch einmal."
                    );
                } else {
                    store.commit(
                        "setErrorMessage",
                        "Es ist ein Fehler aufgetreten. Bitte versuche es später noch einmal oder kontaktiere bei Problemen unser <a href='tel:+4357070777'>Kundenservice</a>."
                    );
                }
                store.commit("setErrors", response.data.Errors);
                store.commit("setError", true);
            }
        }
        return response;
    },
    function (error) {
        // Do something with response error
        store.commit("decrementLoadingCount");
        if (store.state.loadingCount === 0) {
            store.commit("setLoading", false);
        }
        store.commit(
            "setErrorMessage",
            "Das Service ist derzeit nicht erreichbar. Bitte überprüfe deine Internetverbindung oder versuche es später noch einmal."
        );
        store.commit("setError", true);
        return Promise.reject(error);
    }
);

setInterval(function () {
    _axios.post("?Mode=General&Function=Ping");
}, 300000); // 1 mins * 60 * 1000 * 5               = 5min  --> 300000

// Plugin.install = function(Vue, options) {
//   Vue.axios = _axios;
//   window.axios = _axios;
//   Object.defineProperties(Vue.prototype, {
//     axios: {
//       get() {
//         return _axios;
//       }
//     },
//     $axios: {
//       get() {
//         return _axios;
//       }
//     },
//   });
// };

// Vue.use(Plugin)

// export default Plugin;

export { _axios as axios, setAxiosBaseurl };
